export const USER_TYPES = {
  PATIENT: 'patient',
  CAREGIVER: 'caregiver',
  DOCTOR: 'doctor',
  OTHER: 'other',
  PATIENT_NAVIGATOR: 'patient_navigator',
  MEDICAL_TEAM: 'medical_team',
};

export const PLATFORM = {
  HCP: 'HCP',
};

export const USER_SOURCE = {
  HCP: 'HCP',
  PT_UPLOAD_FILE: 'Pt Upload file',
};

export const INFO_ATTRIBUTES = [
  'given_name',
  'first_name',
  'family_name',
  'last_name',
  'phone',
  'last_location',
  'user_role',
  'registered_at',
  'last_modified_at',
  'email',
  'preferred_location',
  'country',
  'partner',
  'gender',
  'dob',
  'user_type',
  'looking_for',
];
